// Anchor ids of the 81 steps in .codex-run/TUTORIAL-STEPS.json, in step order (test keeps them equal).
export const TUTORIAL_ANCHORS = [
  'auth-form',
  'verification-status',
  'consent-choice',
  'workspace-form',
  'workspace-switcher',
  'company-sources',
  'research-progress',
  'research-diff',
  'apply-selection',
  'product-list',
  'product-form',
  'persona-list',
  'persona-form',
  'brand-voice',
  'brand-visual',
  'brand-save',
  'strategy-form',
  'cadence-control',
  'autopilot-toggle',
  'app-home',
  'app-nav',
  'next-step',
  'saved-ideas',
  'create-brief',
  'create-options',
  'create-media-options',
  'generate-button',
  'result-variants',
  'reasoning-panel',
  'draft-save',
  'studio-caption',
  'refine-scope',
  'refine-proposal',
  'version-list',
  'unsaved-status',
  'studio-media',
  'image-generation',
  'image-history',
  'visual-controls',
  'overlay-tools',
  'carousel-slides',
  'thread-editor',
  'media-export',
  'content-library',
  'content-filters',
  'collection-picker',
  'history-list',
  'prompt-library',
  'review-filters',
  'review-card',
  'drip-question',
  'approve-action',
  'reopen-action',
  'calendar-grid',
  'calendar-idea',
  'schedule-dialog',
  'schedule-confirm',
  'delivery-status',
  'delivery-cancel',
  'knowledge-tabs',
  'fact-review',
  'proof-permission',
  'harvest-review',
  'moment-input',
  'learning-rule',
  'learning-evidence',
  'analytics-upload',
  'analytics-mapping',
  'analytics-review',
  'case-study-editor',
  'campaign-blog',
  'settings-nav',
  'preferences-form',
  'notification-preferences',
  'social-connections',
  'subscription-summary',
  'renewal-control',
  'account-export-delete',
  'tutorial-summary',
  'tutorial-chapters',
  'tutorial-resume',
] as const

export type TutorialAnchor = (typeof TUTORIAL_ANCHORS)[number]

export function anchorProps(id: TutorialAnchor): { 'data-tutorial-anchor': TutorialAnchor } {
  return { 'data-tutorial-anchor': id }
}
